import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import clsx from "clsx";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  makeStyles,
  Slide,
  Box,
  Divider,
  Hidden,
  IconButton,
  Fab,
  FormControlLabel,
  Checkbox,
  InputLabel
} from "@material-ui/core";
import {
  VERIFY_ERROR_MESSAGES,
} from "../../utils/constants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from '@material-ui/lab/Alert';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import InputMask from "react-input-mask";
import { Typography, TextField, Button } from "@packages/ui";
import _ from "lodash";

import BookingDetailHeader from "../../components/Checkin/BookingDetailHeader";
import * as checkinActions from "src/actions/checkinActions";

import { ThemeProvider } from "react-jss";

import "react-datepicker/dist/react-datepicker.css";
import "react-multi-carousel/lib/styles.css";
import moment from "moment";
import numeral from "numeral";
import { apiURI } from "../../env";

import { theme } from "../../components/ui/theme";
import SnackBar from "../../layouts/SnackBar";
import {
  REGIONS,
  AU_SEARCHADDRESS,
  AU_RETRIEVEADDRESS,
  NZ_SEARCHADDRESS,
  NZ_RETRIEVEADDRESS,
  UK_SEARCHADDRESS,
  UK_RETRIEVEADDRESS,
  CANADA_SEARCHADDRESS,
  CANADA_RETRIEVEADDRESS,
  INTERNATIONAL_SEARCHADDRESS,
  INTERNATIONAL_RETRIEVEADDRESS,
  AddressSuggestionsWhitelist,
} from "../../utils/constants";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import CloseIcon from "@material-ui/icons/Close";
import { WarningRounded } from "@material-ui/icons";
// import VerifyError from "./VerifyError";
import AddDriverForm from "../../components/AdditionalDriverCheckin/AddDriverForm";
import * as appActions from "../../actions/appActions";
import getCountryFromURL from "src/utils/getCountryFromUrl";

function StyledCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
}

const CheckinApp = () => {
  const classes = useStyles();
  const brand = getBrandFromUrl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkin = useSelector((state) => state.checkin);

  const [dialogBox, setDialogBoxOpen] = useState(false);
  const [expiryDateDialogBox, setexpiryDateDialogBox] = useState({
    dialogue: false,
    finalData: {},
  });
  const [letSessionExpire, setLetSessionExpire] = useState(false);
  const [willExpire, setWillExpire] = useState(false);
  const [sessionTracker, setSessionTracker] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const dataUpdate = useRef(null);
  const [Expand, setExpand] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [inputValueDownShift, setInputValueDownShift] = useState("");
  const [redirectToVerify, setRedirectToVerify] = useState(false);
  const [newContact, setNewContact] = useState({ email: "", phoneNumber: "" });
  // const [verifyFailed, setVerifyFailed] = useState(false);
  // const [addDriverQuestionaireCompleted, setAddDriverQuestionaireCompleted] = useState(!(checkin.verifyCC && checkin.verifyID));
  // const [openUncompleteAddDriverAlert, setOpenUncompleteAddDriverAlert] = useState(false);
  const [isInternationalDL, setIsInternationalDL] = useState(false);
  const [noExpiryChecked, setNoExpiryChecked] = useState(false);

  const isDemo = useSelector((state) => state.checkin.isDemo);

  // let firstName, lastName, street, city, postalCode, countryCode, email, phoneNumber, alternatePhone, drivingLicence, dob;
  const firstName = useSelector((state) => state.checkin.reservation.Renter.RenterName.firstName);
  const lastName = useSelector((state) => state.checkin.reservation.Renter.RenterName.lastName);
  const customerNumber = useSelector((state) => state.checkin.reservation.Renter.customerNumber);
  const email = checkin.reservation?.Renter?.Address?.Email
    ? checkin.reservation?.Renter?.Address?.Email
    : checkin.customer?.LatestCustomer?.Address?.Email || "";
  let phoneNumber = checkin.reservation?.Renter?.Address?.HomeTelephoneNumber
    ? checkin.reservation?.Renter?.Address?.HomeTelephoneNumber
    : checkin.customer?.LatestCustomer?.Address?.HomeTelephoneNumber || "";
  let alternatePhone = checkin.reservation?.Renter?.Address?.CellTelephoneNumber
    ? checkin.reservation?.Renter?.Address?.CellTelephoneNumber
    : checkin.customer?.LatestCustomer?.Address?.CellTelephoneNumber || "";

  const custEmail = useSelector((state) => state.checkin.customer?.LatestCustomer?.Address?.Email);
  const custPhoneNumber = useSelector(
    (state) => state.checkin.customer?.LatestCustomer?.Address?.HomeTelephoneNumber
  );

  const idVerificationSkipped = useSelector((state) => state.checkin.idVerificationSkipped);
  const fromReVerifyID = checkin.requireReVerifyID && (!idVerificationSkipped);
  const loadDetailsFromIdvStatus = (fromReVerifyID) || (checkin.idVerification.TransactionId != null);
  const verifiedTime = useSelector((state) => state.checkin.idVerification?.VerifiedTime);
  const street = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification.Address) : useSelector((state) => state.checkin.reservation.Renter.Address?.Street);
  const city = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification.Suburb) : useSelector((state) => state.checkin.reservation.Renter.Address?.City);
  const postalCode = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification.PostalCode) : useSelector((state) => state.checkin.reservation.Renter.Address?.PostalCode);
  let countryCode = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification.StateCountry) : useSelector((state) => state.checkin.reservation.Renter.Address?.StateOrProvCode);
  countryCode = (countryCode === "" || countryCode === null || countryCode === undefined) ? useSelector((state) => state.checkin.reservation.Renter.Address?.StateOrProvCode) : countryCode;
  const drivingLicence = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification?.LicNo) : useSelector((state) => state.checkin.reservation.Renter.DrivingLicence);
  let dob = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification?.DOB) : useSelector((state) => state.checkin.reservation.Renter.BirthDate);
  let expiry = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification?.DateOfExpiry) : _.get(drivingLicence, "ExpiryDate", null);
  let regionOfIssueCode = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.idVerification?.StateOfIssue) : _.get(drivingLicence, "Issuer", useSelector((state) => state.checkin.reservation.Renter.Address?.RegionOfIssue));
  regionOfIssueCode = (regionOfIssueCode === "" || regionOfIssueCode === null || regionOfIssueCode === undefined) ? _.get(drivingLicence, "Issuer", useSelector((state) => state.checkin.reservation.Renter.Address?.RegionOfIssue)) : regionOfIssueCode;

  let DNR = false;

  const LocationAddress = checkin?.details.Pickup
    ? _.get(checkin, "details.Pickup[0].address1", "") +
    " " +
    _.get(checkin, "details.Pickup[0].address2", "") +
    " " +
    _.get(checkin, "details.Pickup[0].address3", "") +
    " " +
    _.get(checkin, "details.Pickup[0].city", "") +
    " " +
    _.get(checkin, "details.Pickup[0].postCode", "")
    : " ";
  const reservationNumber = useMemo(() => {
    return checkin.resNo;
  }, [checkin.resNo]);
  const randomNumber = useMemo(() => {
    return Math.random();
  }, [checkin.resNo]);
  const countryCodesAU = ["WA", "VI", "TS", "SA", "QL", "NT", "NS", "AC"];

  if (_.has(checkin, "reservation.Renter")) {
    DNR = checkin?.customer?.DNR;
  }

  const currentMainNote = _.get(checkin, "reservation.ReservationMainNote", "");
  let newNote = '';
  if (checkin.idVerification.Verified && checkin.idVerification.OverallResult == "PASS" && checkin.idVerification.FaceMatch == "PASS" && checkin.idVerification.Liveness == "PASS" && checkin.idVerification.DVS == "FAIL" 
    && checkin.idVerification.DocumentVariant !== "LEARNERS"
  ) {
    newNote = currentMainNote.slice(0, currentMainNote.indexOf('|CI')) + (loadDetailsFromIdvStatus ? "|CIW|" : "|CI|");
  } else if (checkin.idVerification.Verified && checkin.idVerification.OverallResult == "PASS" && checkin.idVerification.FaceMatch == "PASS" && checkin.idVerification.Liveness == "PASS" && checkin.idVerification.DVS == "PASS" 
    && checkin.idVerification.DocumentVariant !== "LEARNERS") {
    newNote = currentMainNote.slice(0, currentMainNote.indexOf('|CI')) + (loadDetailsFromIdvStatus ? "|CIP|" : "|CI|");
  } else {
    newNote = currentMainNote.slice(0, currentMainNote.indexOf('|CI')) + (loadDetailsFromIdvStatus ? "|CIF|" : "|CI|");
  }

  useEffect(() => {
    // New customer who just passed id verificatiion, page redirected to chekin-form.
    if (loadDetailsFromIdvStatus && idVerificationSkipped) {
      dispatch(checkinActions.requestIdVerificationStatus({ token: checkin.auth.token, transactionId: checkin.idVerification.TransactionId }));
    } else {
      navigate(`/${isDemo ? 'checkin-demo' : 'checkin'}/checkin-summary`);
    }
  }, []);

  useEffect(() => {
    // If ID verfication return fail from ocrlabs, set verifyFailed to true and redirect to error page
    if (!_.isEmpty(checkin.idVerification.failReasons)) {
      newNote = "|CIF|";
      dispatch(
        checkinActions.updateReservationAndCustomerCIF({
          resno: checkin.resNo,
          MainNote: newNote.slice(0, 30),
          CheckedIn: false,
          CheckinFailed: true,
          FailType: 'IdVerification',
          token: checkin.auth.token,
        })
      );
      if (checkin.customer.LatestCustomer?.customerNumber != null) {
        //If exisiting customer failed the ocrlabs
        console.log('If exisiting customer failed the ocrlabs')
        dispatch(checkinActions.updateCustomer({
          CustomerNumber: checkin.customer.LatestCustomer?.customerNumber,
          brand: brand,
          data: {
            scanDocPass: false,
            verifiedTime
          },
          token: checkin.auth.token,
          country: checkin.country,
          idVerificationSkipped: idVerificationSkipped,
          isAdditionalDriver: false
        }))
      }
    }

    // //If idv status is completed and details fetched, we use idv details to update res and cus
    // if (idVerificationSkipped && loadDetailsFromIdvStatus && !checkin.idVerification.fetchingIdvStatus && checkin.idVerification.TransactionStatus == "COMPLETED_PASS" && _.isEmpty(checkin.idVerification.failReasons)) {
    //   const addressLine = street.slice(0, street.indexOf(city)).trim();
    //   let streetOne = "";
    //   let streetTwo = addressLine;
    //   if (addressLine.length > 30) {
    //     const first30char = street.slice(0, 30);
    //     if (first30char[29] == ' ') {
    //       streetOne = street.slice(0, 30).trim()
    //       streetTwo = street.slice(30, 60)
    //     } else {
    //       const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
    //       streetOne = street.slice(0, street.lastIndexOf(breakingChar));
    //       streetTwo = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
    //     }
    //   }

    //   const data = {
    //     countryCode,
    //     firstName,
    //     lastName,
    //     dob,
    //     postalCode,
    //     city,
    //     street1: streetOne,
    //     street2: streetTwo,
    //     licenceNo: drivingLicence,
    //     regionOfIssue: regionOfIssueCode,
    //     expiry,
    //     email: email ?? "",
    //     contactNumber: phoneNumber ?? "",
    //     emergencyContactNumber: alternatePhone ?? "",
    //     verifiedTime,
    //     scanDocPass: true
    //   }
      
    //   console.log("hello bop bop 0");
    //   console.log("data 0: ", data);

    //   dispatch(
    //     checkinActions.manualUpdateReservationAndCustomerFromIdvResult({
    //       resno: checkin.resNo,
    //       MainNote: newNote.slice(0, 30),
    //       CustomerNumber: checkin?.customer?.LatestCustomer?.customerNumber,
    //       CheckedIn: false,
    //       brand: brand,
    //       data: data,
    //       otherid: _.get(checkin, "OtherID", ""),
    //       token: checkin.auth.token,
    //       country: checkin.country,
    //     })
    //   );
    // }
      
    // // If ID Check is not skipped and ID check is a success, update reservation and customer straight away and redirect to checkin summary page instead of checkin form page
    // if (!idVerificationSkipped && _.isEmpty(checkin.idVerification.failReasons) 
    //   && firstName && lastName && phoneNumber && email && city && countryCode && dob && expiry && drivingLicence && postalCode
    // ) {  
    //   let addressLine = street.slice(0, street.indexOf(city)).trim();
    //   if (addressLine.length > 30) {
    //     let streetOne, streetTwo

    //     const first30char = street.slice(0, 30);
    //     if (first30char[29] == ' ') {
    //       streetOne = street.slice(0, 30).trim()
    //       streetTwo = street.slice(30, 60)
    //     } else {
    //       const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
    //       streetOne = street.slice(0, street.lastIndexOf(breakingChar));
    //       streetTwo = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
    //     }
    //     addressLine = streetOne + ',' + streetTwo
    //   }

    //   const data = {
    //     firstName,
    //     lastName,
    //     contactNumber: phoneNumber,
    //     emergencyContactNumber: alternatePhone,
    //     email,
    //     Suburb: '',
    //     city,
    //     countryCode: countryCode,
    //     dob,
    //     expiry,
    //     licenceNo: drivingLicence,
    //     postalCode,
    //     regionOfIssue: regionOfIssueCode,
    //     street2: addressLine,
    //     unitNumber,
    //     scanDocPass: true,
    //     verifiedTime
    //   };

    //   onSubmit(data);
    // }
  }, [checkin.idVerification]);

  useEffect(() => {
    const suggestionCountry = _.get(getValues("countryCode"), "value", "");

    if (countryCodesAU.includes(suggestionCountry)) {
      setSuggestions(
        _.filter(_.get(checkin, "addressSuggestions", []), function (o) {
          return _.includes(o.label, suggestionCountry);
        })
      );
    } else {
      setSuggestions(checkin.addressSuggestions);
    }
  }, [checkin.addressSuggestions]);

  useEffect(() => {
    const suggestionCountry = _.get(getValues("countryCode"), "value", "");

    if (countryCodesAU.includes(suggestionCountry)) {
      setSuggestions(
        _.filter(_.get(checkin, "addressSuggestions", []), function (o) {
          return _.includes(o.label, suggestionCountry);
        })
      );
    } else {
      setSuggestions(checkin.addressSuggestions);
    }
  }, [checkin.Renter]);

  if (_.has(checkin, "customer.DNR")) {
    DNR = checkin?.customer?.DNR;
  }

  expiry = expiry != null ? moment(expiry).format("DD/MM/YYYY") : null;

  const isDisableDob = !_.isEmpty(dob);

  const isDisableExpiry = !_.isEmpty(expiry);

  dob = moment(dob).format("DD/MM/YYYY");


  const country = countryCode != null ? REGIONS.filter((code) => code.value == countryCode) : null;
  const regionOfIssue =
    regionOfIssueCode != null ? REGIONS.filter((code) => code.value == regionOfIssueCode) : null;

  if (!_.isEmpty(phoneNumber)) {
    phoneNumber = phoneNumber.includes("++") ? "+" + phoneNumber.split("++")[1] : phoneNumber;
  }

  if (!_.isEmpty(alternatePhone)) {
    alternatePhone = alternatePhone.includes("++")
      ? "+" + alternatePhone.split("++")[1]
      : alternatePhone;
  }

  let street1 = "";
  let street2 = "";
  let unitNumber = "";

  if (_.isArray(street)) {
    street1 = street[0];
    street2 = street[1];
  } else if (street != undefined) {
    const first30char = street.slice(0, 30);
    if (first30char[29] == ' ') {
      street1 = street.slice(0, 30).trim()
      street2 = street.slice(30, 60)
    } else {
      const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
      street1 = street.slice(0, street.lastIndexOf(breakingChar));
      street2 = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
    }
  }

  if (street1.includes("undefined")) {
    street1 = "";
  }
  if (street2.includes("undefined")) {
    street2 = "";
  }

  let isStreet2IncludesUnitNumber;

  if (!_.isEmpty(street2)) {
    isStreet2IncludesUnitNumber = street2.includes("-");
  }

  if (isStreet2IncludesUnitNumber) {
    unitNumber = street2.split("-")[0];
    street2 = street2.split("-")[1];
  }
  if (!_.isEmpty(street1)) {
    street2 = street1 + ", " + street2;
  }

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    contactNumber: Yup.string()
      .required("Required")
      .max(15, "Contact Number must be less then 15 numbers ")
      .matches(
        /^[1-9]{1}[0-9]{7,11}$/,
        "Please Enter mobile number in countrycode followed by mobile number format"
      ),
    alternatePhone: Yup.string().test(
      "contact Number match",
      "Please use different phone Number",
      function (value) {
        return this.parent.contactNumber != value;
      }
    ),
    email: Yup.string().email().required("Required"),
    street2: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    countryCode: Yup.object().required("Required").nullable(),
    dob: Yup.string()
      .required("Required")
      .matches(
        /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
        "Please Enter Date in dd/mm/yyyy Format"
      )
      .test("dob", "You must be 18 years old", function (birthdate) {
        const cutoff = new Date();
        cutoff.setFullYear(cutoff.getFullYear() - 18);
        const dob = new Date(moment(birthdate, "DD/MM/YYYY").format("YYYY-MM-DD"));
        return dob <= cutoff;
      })
      .test("dob", "You must be less than 100 years", function (birthdate) {
        const limit = new Date();
        limit.setFullYear(limit.getFullYear() - 100);
        const bd = new Date(moment(birthdate, "DD/MM/YYYY").format("YYYY-MM-DD"));
        return bd > limit;
      }),
    licenceNo: Yup.string()
      .required("Required")
      .matches(/^[a-zA-Z0-9-]*$/, "Licence Number should only have Letters, Numbers, Hyphen")
      .max(20, "Driving Licence should not have more than 20 characters"),
    expiry: Yup.string()
      .matches(
        /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
        { message: "Please Enter Date in dd/mm/yyyy Format", excludeEmptyString: true }
      )
      .test("expiry", "Please enter valid expiry date", function (expiry) {
        if (expiry) {
          const date = new Date();
          const expiryDate = new Date(moment(expiry, "DD/MM/YYYY").format("YYYY-MM-DD"));
          return expiryDate > date;
        } else {
          return true;
        }
      }),
    regionOfIssue: Yup.object().required("Required").nullable(),
  });

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      firstName: firstName ? firstName : "",
      lastName: lastName ? lastName : "",
      contactNumber: _.isEmpty(phoneNumber)
        ? " "
        : phoneNumber.includes("+")
          ? phoneNumber.split("+")[1]
          : phoneNumber,
      alternatePhone: _.isEmpty(alternatePhone)
        ? ""
        : alternatePhone.includes("+")
          ? alternatePhone.split("+")[1]
          : alternatePhone,
      email: email ? email : "",
      street2: street2 ? street2 : "",
      city: city ? city : "",
      countryCode: countryCode ? country[0] : "",
      unitNumber: unitNumber ? unitNumber : "",
      postalCode: postalCode ? postalCode : "",
      dob: dob ? dob : "",
      licenceNo: drivingLicence?.Number ? drivingLicence.Number : "",
      expiry: expiry ? expiry : "",
      regionOfIssue: regionOfIssueCode ? regionOfIssue[0] : "",
      Suburb: "",
    },
  });

  useEffect(() => {
    if (!drivingLicence && checkin.LicenceNumber) {
      setValue("licenceNo", checkin.LicenceNumber);
    }
    setInputValueDownShift(street2 ? street2 : "");
    dispatch(checkinActions.setRequireReVerifyCC({ requireReVerifyCC: false }));
  }, []);

  useEffect(() => {
    if (_.has(checkin, 'selectedAddress.address.AddressLine')) {
      if (_.get(checkin, 'selectedAddress.selectedCountry') != 'AU' || _.get(checkin, 'selectedAddress.selectedCountry') != 'NZ') {
        const addressLine1 = checkin.selectedAddress.address.AddressLine1 ?? " ";
        const addressLine2 = checkin.selectedAddress.address.AddressLine2 ?? " ";
        setInputValueDownShift(addressLine1 + ',' + addressLine2)
        setValue("street2", addressLine1 + ',' + addressLine2)
        setValue("city", checkin.selectedAddress.address.LocalityCityTown)
        setValue("postalCode", checkin.selectedAddress.address.Postcode)
      }
      if (_.get(checkin, 'selectedAddress.selectedCountry') == 'AU') {
        setInputValueDownShift(checkin.selectedAddress.address.AddressLine)
        setValue("street2", checkin.selectedAddress.address.AddressLine)
        setValue("city", checkin.selectedAddress.address.Locality)
        setValue("postalCode", checkin.selectedAddress.address.Postcode)
      }
      else if (_.get(checkin, 'selectedAddress.selectedCountry') == 'NZ') {
        const Suburb = checkin.selectedAddress.address.Suburb != "" ? ", " + checkin.selectedAddress.address.Suburb : "";
        setInputValueDownShift(checkin.selectedAddress.address.AddressLine + Suburb)
        setValue("street2", checkin.selectedAddress.address.AddressLine + checkin.selectedAddress.address.Suburb == "" ? "" : " " + checkin.selectedAddress.address.Suburb)
        setValue("city", checkin.selectedAddress.address.TownCityMailtown)
        setValue("postalCode", checkin.selectedAddress.address.Postcode)
      }

    }
  }, [checkin.selectedAddress.address])

  const estimatecharges = [];
  //   // Day Rate Calculation

  let dayRate = _.find(checkin?.estimate?.Estimate?.Customer?.TimeCharges, function (ratesObject) {
    if (_.includes(ratesObject.Description, "DAYS")) {
      return ratesObject;
    }
  });

  if (dayRate != undefined) {
    estimatecharges.push(dayRate);
  } else {
    dayRate = { Quantity: "0", SubTotal: "0" };
  }

  //Discount Rate

  const discountRate = _.find(checkin?.estimate?.Estimate?.Customer?.TimeCharges, function (
    discountObject
  ) {
    if (_.includes(discountObject.Description, "Discount") && discountObject.SubTotal != 0) {
      return discountObject;
    }
  });

  if (_.has(discountRate, "Discount")) {
    estimatecharges.push(discountRate);
  }

  if (checkin.PrePaid == true) {
    dayRate = { Quantity: "", SubTotal: "Prepaid" };
  }
  // rental Estimates

  const RenterCharges = [];
  _.reduce(
    _.get(checkin, "estimate.Estimate.Customer.OptionsCharges", []),
    function (accumulator, batch) {
      if (_.has(batch, "Quantity")) {
        const { Quantity, SubTotal, Description } = batch;
        if (parseInt(Quantity) != 0 && parseInt(SubTotal) != 0) {
          RenterCharges.push(batch);
          estimatecharges.push(batch);
        }
      }
    },
    0
  );

  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();

  const [form, setForm] = useState({
    ..._.cloneDeep(checkin.reservation).Renter,
    ReservationMainNote: checkin.reservation.ReservationMainNote,
    TermsAndConditions: false,
  });

  const Countries = _.sortBy(REGIONS, ["label"]);

  const options = Countries.map((option) => {
    const countryFirstLetter = option.country[0].toLocaleUpperCase();
    return {
      countryFirstLetter: countryFirstLetter,
      ...option,
    };
  });

  useEffect(() => {
    if (checkin?.checkinComplete == true) {
      navigate(`/${isDemo ? 'checkin-demo' : 'checkin'}/checkin-summary`);
    }
  }, [checkin.checkinComplete]);

  useEffect(() => {
    setLetSessionExpire(false);
    clearInterval(sessionTracker);
    setSessionTracker(
      setInterval(() => {
        const sessionExpiry = _.get(checkin, "auth.expires", moment().subtract(0, "m").unix());
        if (moment().isAfter(moment.unix(sessionExpiry))) {
          window.location.replace(`/${isDemo ? 'checkin-demo' : 'checkin'}/login`);
        }
        const isExpiring = moment().add(2, "m").isAfter(moment.unix(sessionExpiry));
        setWillExpire(isExpiring);
      }, 10000)
    );
    setWillExpire(false);
  }, [checkin.auth.expires]);

  useEffect(() => {
    dataUpdate.current = true;
    if (dataUpdate.current) {
      dispatch(
        checkinActions.getDetails({
          reservation: checkin.reservation,
          token: checkin.auth.token,
        })
      );
      dispatch(
        checkinActions.frontdeskGetEstimate({
          resno: checkin.resNo,
          token: checkin.auth.token,
        })
      );
      dispatch(
        checkinActions.resOptions({
          resno: checkin.resNo,
          token: checkin.auth.token,
        })
      );
    }
    return () => (dataUpdate.current = false);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(checkin.reservation)) {
      estimateReservation();
    }
  }, [checkin.reservation]);

  const estimateReservation = () => {
    const { ReservationMainNote, ...Renter } = form;
    const RateID = _.find(checkin.details?.WebRates?.Rates, {
      Class: checkin.reservation.Vehicle.classCode,
    })?.RateID;

    // if (!_.isEmpty(checkin.details?.WebRates?.Rates)) {
    //   dispatch(
    //     checkinActions.resEstimate({
    //       token: checkin.auth.token,
    //       ReservationMainNote,
    //       Renter,
    //       RateID,
    //       Reservation: checkin.reservation,
    //     })
    //   );
    // }
  };

  const [values, setValues] = React.useState(countryCode ? country[0] : "");
  const [inputValue, setInputValue] = React.useState("");

  const placeholder = "DD/MM/YYYY";
  const formatChars = {
    n: "[0-3]",
    m: "[0-9]",
    e: "[0-1]",
    d: "[0-9]",
    z: "[1-2]",
    y: "[0-9]",
  };

  // Get customer details from idverification query transaction, and load values into form fields
  useEffect(() => {
    if (checkin.idVerification.TransactionStatus != undefined) {
      // const stateOfIssueCode = checkin.idVerification.StateOfIssue;
      const addressStateCode = checkin.idVerification.StateCountry;
      let addressLine = street.slice(0, street.indexOf(city)).trim();

      if (addressLine.length > 30) {
        let streetOne, streetTwo

        const first30char = street.slice(0, 30);
        if (first30char[29] == ' ') {
          streetOne = street.slice(0, 30).trim()
          streetTwo = street.slice(30, 60)
        } else {
          const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
          streetOne = street.slice(0, street.lastIndexOf(breakingChar));
          streetTwo = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
        }
        addressLine = streetOne + ',' + streetTwo
      }

      const addressState = REGIONS.filter((code) => code.value == addressStateCode);
      // const regionOfIssue = REGIONS.filter((code) => code.value == stateOfIssueCode);
      const regionOfIssue = REGIONS.filter((code) => code.value == regionOfIssueCode);
      if (regionOfIssue.length && !["AUSTRALIA", "NEW ZEALAND"].includes(regionOfIssue[0].country)) {
        setIsInternationalDL(true);
      } else {
        setIsInternationalDL(false);
      }

      setInputValueDownShift(addressLine);

      setValue(
        "city", city
      );
      setValue(
        "licenceNo", drivingLicence
      );
      setValue(
        "expiry", expiry
      );
      setValue(
        "postalCode", postalCode
      );
      setValue(
        "dob", dob
      );
      setValue(
        "street2", addressLine
      );
      setValue(
        "countryCode", addressState[0],
      );
      setValue(
        "regionOfIssue", regionOfIssue[0],
      );
    }
  }, [regionOfIssue, countryCode]);

  const handleClose = () => {
    dispatch(checkinActions.logout());
    // Token empty set false
    setDialogBoxOpen(false);
  };

  // This code is to handle when closing a dialog that opens (once id check is completed, if the customer dl expire within the renting period), 
  // after closing this dialog reminder to the customer, we update reservation and customer
  const handleDialogeClose = () => {
    // console.log(expiryDateDialogBox.dialogue);
    setexpiryDateDialogBox({ dialogue: false });
    dispatch(
      checkinActions.updateReservationAndCustomer({
        resno: checkin.resNo,
        MainNote: newNote.slice(0, 30),
        CustomerNumber: checkin?.customer?.LatestCustomer?.customerNumber,
        name:
          checkin.reservation.Renter.RenterName.firstName +
          " " +
          checkin.reservation.Renter.RenterName.lastName,
        brand: brand,
        total: numeral(_.get(checkin, "estimate.Estimate.Total", 0)).format("0,0.00"),
        confNo: _.isEmpty(checkin.confNo) ? "--" : checkin.confNo,
        pickupDate: moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
          "DD-MMM-YY"
        ),
        pickupTime: moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
          "LT"
        ),
        pickupLocation: checkin?.details?.Pickup ? checkin.details.Pickup[0]?.locationName : "",
        locationAddress: LocationAddress,
        date: `${moment().format("LLL")} AEST`,
        estimate: estimatecharges,
        data: expiryDateDialogBox.finalData,
        otherid: _.get(checkin, "OtherID", ""),
        token: checkin.auth.token,
        country: checkin.country,
        prepaid: checkin.PrePaid,
        verifiedTime,
        scanDocPass: true,
        idVerificationSkipped: !loadDetailsFromIdvStatus && idVerificationSkipped
      })
    );
  };

  const onExtendSession = () => {
    dispatch(checkinActions.extendSession());
  };

  const setSummaryExpanded = () => {
    setExpand(!Expand);
  };

  const onSubmit = (data) => {
    // if (!addDriverQuestionaireCompleted && !checkin.hasSMSSendRecord && idVerificationSkipped) {
    //   setOpenUncompleteAddDriverAlert(true);
    //   return
    // }

    if (DNR) {
      setDialogBoxOpen(true);
    } else {
      // console.log("data blah blah: ", data);
      // const countryCode = !idVerificationSkipped ? data.countryCode : data.countryCode.value;
      // const regionOfIssue = !idVerificationSkipped ? data.regionOfIssue : data.regionOfIssue.value;
      const countryCode = data.countryCode.value;
      const regionOfIssue = data.regionOfIssue.value;
      const contactNumber = data.contactNumber.includes("+")
        ? data.contactNumber
        : "+" + data.contactNumber;
      const alternatePhone = data.alternatePhone.includes("+")
        ? data.alternatePhone
        : _.isEmpty(data.alternatePhone)
          ? " "
          : "+" + data.alternatePhone;
      const isSplitStreet = data.street2.includes(",");
      let street1 = "";
      let street2 = "";
      if (isSplitStreet) {
        street1 = data.street2.split(",")[0];
        street2 = data.street2.split(",")[1].trim();
      } else if (data.street2.length > 30) {
        const street = data.street2;
        const first30char = street.slice(0, 30);
        if (first30char[29] == ' ') {
          street1 = street.slice(0, 30).trim()
          street2 = street.slice(30, 60)
        } else {
          const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
          street1 = street.slice(0, street.lastIndexOf(breakingChar));
          street2 = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
        }
      } else {
        street2 = data.street2.trim();
      }
      if (data.unitNumber != "") {
        street1 = data.unitNumber + "-" + street1;
      }
      data = {
        ...data,
        regionOfIssue: regionOfIssue ? regionOfIssue.toUpperCase() : "",
        countryCode: countryCode ? countryCode.toUpperCase() : "",
        street1,
        street2,
        contactNumber: contactNumber ?? "",
        emergencyContactNumber: alternatePhone ?? "",
        verifiedTime,
        scanDocPass: true
      };

      const returnDate = moment(
        checkin?.reservation?.Return?.dateTime,
        "YYYY-MM-DDTh:mm:ss"
      ).format("MM-DD-YYYY");

      // // if return customers contact details was edited (phone number or email) then make customer redo id check!
      // if (customerNumber != "999999" && checkin.verifyCC && checkin.verifyID && !fromReVerifyID) {
      //   if ((custEmail != null && !data.email.includes(custEmail))) {
      //     console.log('email or phone NO changed');
      //     setRedirectToVerify(true);
      //     setNewContact({ email: data.email, phoneNumber: data.contactNumber })
      //     return
      //   } else if (custPhoneNumber != null && custPhoneNumber != 'NULL') {
      //     if (data.contactNumber.slice(-5) != custPhoneNumber.slice(-5)) {
      //       setRedirectToVerify(true);
      //       setNewContact({ email: data.email, phoneNumber: data.contactNumber })
      //       return
      //     }
      //   }
      // }

      if (new Date(returnDate) > new Date(moment(data.expiry, "DD/MM/YYYY").format("MM-DD-YYYY"))) {
        setexpiryDateDialogBox({ dialogue: true, finalData: data });
      } else {
        dispatch(
          checkinActions.updateReservationAndCustomer({
            resno: checkin.resNo,
            MainNote: newNote.slice(0, 30),
            CustomerNumber: checkin?.customer?.LatestCustomer?.customerNumber,
            name:
              checkin.reservation.Renter.RenterName.firstName +
              " " +
              checkin.reservation.Renter.RenterName.lastName,
            brand: brand,
            total: numeral(_.get(checkin, "estimate.Estimate.Total", 0)).format("0,0.00"),
            confNo: _.isEmpty(checkin.confNo) ? "--" : checkin.confNo,
            pickupDate: moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
              "DD-MMM-YY"
            ),
            pickupTime: moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
              "LT"
            ),
            pickupLocation: checkin?.details?.Pickup ? checkin.details.Pickup[0]?.locationName : "",
            locationAddress: LocationAddress,
            date: `${moment().format("LLL")} AEST`,
            otherid: _.get(checkin, "OtherID", ""),
            estimate: estimatecharges,
            data: data,
            token: checkin.auth.token,
            country: checkin.country,
            prepaid: checkin.PrePaid,
            idVerificationSkipped: !loadDetailsFromIdvStatus && idVerificationSkipped
          })
        );

        if (checkin.customer.LatestCustomer?.customerNumber != null) { //If exisiting customer, update cus profile
          checkinActions.updateCustomer({
            resno: checkin.resNo,
            CustomerNumber: checkin.customer.LatestCustomer?.customerNumber,
            brand: brand,
            data: data,
            token: checkin.auth.token,
            country: checkin.country,
            idVerificationSkipped: idVerificationSkipped
          })
        }
      }
    }
  };

  const handleClickedSubmit = () => {
    const err = Object.keys(errors);
    console.log("err: ", err);
    if (err.length) {
      const input = document.querySelector(
        `#${err[0]}`
      );

      if (!_.isEmpty(input)) {
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start',
        });
      }
    }
  }

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleAddressChange = (e) => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    if (e?.target?.value?.length > 4 && e?.target?.value?.length % 4 == 0) {
      // console.log(_.get(getValues("countryCode"), "value", ""));
      if (AddressSuggestionsWhitelist.includes(_.get(getValues("countryCode"), "value", ""))) {
        dispatch(
          checkinActions.searchAddress({
            token: checkin.auth.token,
            address: e.target.value,
            countryCode: getValues("countryCode").value
              ? countryCodesAU.includes(getValues("countryCode").value)
                ? "AU"
                : getValues("countryCode").value
              : "AU",
            method:
              _.get(getValues("countryCode"), "value", "") == "NZ"
                ? NZ_SEARCHADDRESS
                : _.get(getValues("countryCode"), "value", "") == "GB"
                  ? UK_SEARCHADDRESS
                  : _.get(getValues("countryCode"), "value", "") == "CA"
                    ? CANADA_SEARCHADDRESS
                    : _.has(getValues("countryCode"), "value") &&
                      countryCodesAU.includes(_.get(getValues("countryCode"), "value", "")) != true
                      ? INTERNATIONAL_SEARCHADDRESS
                      : AU_SEARCHADDRESS,
          })
        );
      }
    }
  };

  const selectedAddress = (data) => {
    dispatch(
      checkinActions.retrieveAddress({
        token: checkin.auth.token,
        countryCode: getValues("countryCode").value
          ? countryCodesAU.includes(getValues("countryCode").value)
            ? "AU"
            : getValues("countryCode").value
          : "AU",
        method:
          _.get(getValues("countryCode"), "value", "") == "NZ"
            ? NZ_RETRIEVEADDRESS
            : _.get(getValues("countryCode"), "value", "") == "GB"
              ? UK_RETRIEVEADDRESS
              : _.get(getValues("countryCode"), "value", "") == "CA"
                ? CANADA_RETRIEVEADDRESS
                : _.has(getValues("countryCode"), "value") &&
                  countryCodesAU.includes(_.get(getValues("countryCode"), "value", "")) != true
                  ? INTERNATIONAL_RETRIEVEADDRESS
                  : AU_RETRIEVEADDRESS,
        recordId: data.value,
      })
    );
  };

  const handleConfirmRedirectToVerify = () => {
    // dispatch(checkinActions.setRequireReVerifyCC({ requireReVerifyCC: true }));
    dispatch(checkinActions.setRequireReVerifyID({ requireReVerifyID: true }));
    dispatch(checkinActions.resetVerifyStatus());
    dispatch(checkinActions.updateCustomerContact(newContact));

    navigate(`/${isDemo ? "checkin-demo" : "checkin"}/verify`, { replace: true });
    // navigate(`/${isDemo ? 'checkin-demo' : 'checkin'}/privacy/${brand.toLowerCase()}`, { replace: true });
  }

  const renderInput = (inputprops) => {
    const { InputProps, classes, ref, value, ...other } = inputprops;
    return (
      <TextField
        fullWidth
        name="street2"
        label="Address"
        value={value}
        InputProps={{
          inputRef: ref,
          autoComplete: "new-password",
          classes: {
            root: classes.input,
          },
          ...InputProps,
        }}
        {...other}
      />
    );
  };

  const getFutureDate = () => {
    const futureDate = new Date();
    futureDate.setFullYear(futureDate.getFullYear() + 2);
    return moment(futureDate).format("DD/MM/YYYY");
  };

  const handleCheckboxChange = (e, onChange) => {
    const isChecked = e.target.checked;
    const newValue = isChecked ? getFutureDate() : expiry || "";
    setNoExpiryChecked(isChecked)
    onChange(newValue);
  };

  return (
    (checkin.loading || checkin.idVerification.fetchingIdvStatus) ? (<Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={true}
      BackdropComponent={Backdrop}
    >
      <Fade in={true} style={{ textAlign: "center" }}>
        <React.Fragment>
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
            <div><p>{checkin.idVerification.fetchingIdvStatus ? 'Loading your details...\nThis could take 1 -2 minutes' : 'Submitting'}</p></div>
          </div>

          {/* <div hidden={iframeLoading}>
            <div className={classes.iframe}>
              <iframe
                src={checkin.windcave.Url}
                height="100%"
                width="100%"
                frameBorder="0"
                onLoad={iframeOnLoad}
              >
                Your browser doesnot support iframes
        <a href={cardValidationStatus.Url}> click here to view the page directly. </a>
              </iframe>
            </div>
          </div> */}
        </React.Fragment>
      </Fade>
    </Modal>) : 
    // (verifyFailed ? <VerifyError /> : 
    (!idVerificationSkipped ? 
      (<Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={true}
        BackdropComponent={Backdrop}
      >
        <Fade in={true} style={{ textAlign: "center" }}>
          <React.Fragment>
            <div style={{ textAlign: "center" }}>
              <CircularProgress />
              <div><p>{checkin.idVerification.fetchingIdvStatus ? 'Loading your details...\nThis could take 1 -2 minutes' : 'Submitting'}</p></div>
            </div>
          </React.Fragment>
        </Fade>
      </Modal>) 
    : 
      <div>
        <SnackBar />
        <ThemeProvider theme={theme} className={classes.removeContainer}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ marginTop: 20 }}
          >
            {/* <Grid item xs={12} lg={8} md={10} style={{ marginTop: 20, marginBottom: 20 }}>
              <Accordion
                className={classes.accordion}
                expanded={Expand}
                onChange={() => setSummaryExpanded(!expanded)}
                ref={myRef}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
                  aria-controls={`panel1a-content`}
                  id={`panel1a-header`}
                  className={classes.summary}
                >
                  <Typography className={classes.headerFont} variant={"h3"}>
                    Booking Summary
                  </Typography>
                </AccordionSummary>
                <BookingDetailHeader />
                <AccordionDetails>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ textAlign: "center" }}
                  >
                    <Grid item xs={12}>
                      <Typography variant={"h2"} style={{ margin: 10 }}>
                        {checkin?.details?.Vehicle
                          ? _.get(checkin, "details.Vehicle[0].title", " ") + " or Similar"
                          : ""}
                      </Typography>
                    </Grid>
                    {brand == "Hertz" && (
                      <Grid item xs={12}>
                        <img
                          src={`https://images.hertz.com/vehicles/220x128/${checkin?.details?.Vehicle
                            ? _.get(checkin, "details.Vehicle[0].image", "")
                            : ""
                            }`}
                        />
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid> */}
            <Grid item xs={12} lg={8} md={10} style={{ marginTop: 0 }}>
              <Accordion
                className={classes.accordion}
                expanded={true}
                onChange={() => setExpanded(!expanded)}
                ref={myRef}
              >
                <AccordionSummary
                  aria-controls={`panel1a-content`}
                  id={`panel1a-header`}
                  className={classes.summary}
                >
                  <Typography className={classes.headerFont} variant={"h3"}>
                    Personal Information
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container direction="row" justify="center" alignItems="center" spacing={1}>

                    {/* <Grid item xs={12} style={{ marginTop: 20, marginBottom: 10 }}>
                      <Typography variant={"h3"}>
                        Renter Information (Full License Required)
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        control={control}
                        name="firstName"
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            required
                            disabled
                            fullWidth
                            id="firstName"
                            name="firstName"
                            label="First Name"
                            value={value}
                            error={errors.firstName ? true : false}
                            onChange={onChange}
                            helperText={errors.firstName ? errors.firstName.message : null}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        control={control}
                        name="lastName"
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            required
                            disabled
                            fullWidth
                            id="lastName"
                            name="lastName"
                            label="Last Name"
                            value={value}
                            error={errors.lastName ? true : false}
                            onChange={onChange}
                            helperText={errors.lastName ? errors.lastName.message : null}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Controller
                        control={control}
                        name="email"
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            inputProps={{
                              autoComplete: "new-password",
                            }}
                            required
                            fullWidth
                            id="email"
                            name="email"
                            label="Email"
                            value={value}
                            error={errors.email ? true : false}
                            onChange={onChange}
                            helperText={errors.email ? errors.email.message : null}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} id="contactNumber">
                      <Controller
                        control={control}
                        name="contactNumber"
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            preferredCountries={["au", "nz"]}
                            placeholder={"+61"}
                            country={"au"}
                            // inputStyle={{ width: "100%" }}
                            name="contactNumber"
                            id="contactNumber"
                            style={{marginBottom: '4px', marginTop: '4px'}}
                            inputStyle={{ width: "100%", height: "100%", color: "#263238" }}
                            buttonStyle={{
                              paddingTop:'18px'
                            }}
                            specialLabel={<span style={{ color: "rgb(84, 110, 122)" }}>Mobile/Phone Number *</span>}
                            // specialLabel="Mobile/Phone Number *"
                            error={errors.contactNumber ? true : false}
                            helperText={errors.contactNumber ? errors.contactNumber.message : null}
                            onChange={onChange}
                          />
                        )}
                      />
                      {errors.contactNumber && (
                        <p
                          style={{
                            color: "#f44336",
                            fontSize: "0.75rem",
                            marginLeft: "14px",
                            marginRight: "14px",
                          }}
                        >
                          {errors.contactNumber.message}
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Controller
                        control={control}
                        name="alternatePhone"
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            preferredCountries={["au", "nz"]}
                            placeholder={"+61"}
                            country={"au"}
                            // inputStyle={{ width: "100%" }}
                            name="alternatePhone"
                            id="alternatePhone"
                            style={{marginBottom: '4px', marginTop: '4px'}}
                            inputStyle={{ width: "100%", height: "100%", color: "#263238" }}
                            buttonStyle={{
                              paddingTop:'18px'
                            }}
                            specialLabel={<span style={{ color: "rgb(84, 110, 122)" }}>Alternate Contact Number *</span>}
                            // specialLabel="Emergency Contact Number"
                            error={errors.alternatePhone ? true : false}
                            helperText={
                              errors.alternatePhone
                                ? errors.alternatePhone.message
                                : null
                            }
                            onChange={onChange}
                          />
                        )}
                      />
                      {errors.alternatePhone && (
                        <p
                          style={{
                            color: "#f44336",
                            fontSize: "0.75rem",
                            marginLeft: "14px",
                            marginRight: "14px",
                          }}
                        >
                          {errors.alternatePhone.message}
                        </p>
                      )}
                    </Grid> */}

                    <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                      {/* <Divider style={{ marginTop: 20, marginBottom: 20 }} /> */}
                      <Typography variant={"h3"}>Address</Typography>
                    </Grid>
                    {getValues("countryCode") == null && <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <Alert style={{ marginTop: 15 }} severity="warning">Please select State/Country, for better suggestions in address lookup</Alert>
                    </Grid>}
                    <Grid item xs={12} md={4}>
                      <Controller
                        name="countryCode"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            options={options
                              .sort(
                                (a, b) => -b.countryFirstLetter.localeCompare(a.countryFirstLetter)
                              )
                              .sort()}
                            groupBy={(option) => option.country}
                            value={value}
                            // defaultValue={options.find((element) => element.label == value.label)}
                            onChange={(_, newValue) => {
                              setValues(newValue);
                              setValue("countryCode", newValue);
                            }}
                            // inputValue={inputValue}
                            onInputChange={(_, newInputValue) => {
                              setInputValue(newInputValue);
                            }}
                            inputProps={{
                              autoComplete: "new-password",
                              form: {
                                autocomplete: "off",
                              },
                            }}
                            getOptionLabel={(option) => (option.label ? option.label : "")}
                            getOptionSelected={(option) => value}
                            renderInput={(params) => (
                              <TextField
                                required
                                fullWidth
                                autoComplete="new-password"
                                inputProps={{
                                  autoComplete: "new-password",
                                  form: {
                                    autocomplete: "off",
                                  },
                                }}
                                error={errors.countryCode ? true : false}
                                helperText={errors.countryCode ? "Required" : null}
                                {...params}
                                label="State/Country"
                                variant="outlined"
                              />
                            )}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={8} id="street2">
                      <Controller
                        name="street2"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            freeSolo
                            filterOptions={(options, state) => options}
                            disableClearable
                            options={inputValueDownShift.length > 4 ? suggestions : []}
                            inputValue={inputValueDownShift}
                            getOptionLabel={(option) =>
                              _.isObject(option) ? option.label : option ? option : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                inputProps={{
                                  autoComplete: "new-password",
                                }}
                                {...params}
                                label="Address Lookup"
                                variant="outlined"
                                required
                              />
                            )}
                            onInputChange={(value) => {
                              handleAddressChange(value);
                              // console.log(_.get(value, "target.value", ""));
                              // console.log(value);
                              setInputValueDownShift(_.get(value, "target.value", ""));

                            }}
                            onChange={(_, data) => {
                              selectedAddress(data);
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Controller
                        name="city"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            required
                            fullWidth
                            inputProps={{
                              autoComplete: "new-password",
                            }}
                            id="city"
                            name="city"
                            label="City/Suburb"
                            value={value}
                            error={errors.city ? true : false}
                            onChange={onChange}
                            helperText={errors.city ? errors.city.message : null}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Controller
                        name="postalCode"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            fullWidth
                            id="postalCode"
                            name="Postal Code"
                            inputProps={{
                              autoComplete: "new-password",
                            }}
                            label="Postal Code"
                            value={value}
                            error={errors.postalCode ? true : false}
                            onChange={onChange}
                            helperText={errors.postalCode ? errors.postalCode.message : null}
                          />
                        )}
                      />
                    </Grid>
                    {/* <Grid item xs={12} style={{ marginBottom: 20 }}>
                      <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                      <Typography variant={"h3"}>Driver&apos;s License</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        name="dob"
                        control={control}
                        render={({ field: { onChange, ref, value }, formState }) => (
                          <InputMask
                            alwaysShowMask={false}
                            formatChars={formatChars}
                            maskChar=" "
                            // disabled={isDisableDob}
                            mask="nm/ed/zyyy"
                            onChange={onChange}
                            value={value}
                          >
                            {() => (
                              <TextField
                                placeholder="DD/MM/YYYY"
                                label="Date Of Birth (dd/mm/yyyy)"
                                fullWidth
                                required
                                error={errors.dob ? true : false}
                                helperText={errors.dob ? errors.dob.message : null}
                              />
                            )}
                          </InputMask>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        control={control}
                        name="licenceNo"
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            fullWidth
                            required
                            id="licenceNo"
                            name="licenceNo"
                            label="Licence Number"
                            value={value}
                            // disabled={drivingLicence != undefined}
                            error={errors.licenceNo ? true : false}
                            onChange={onChange}
                            helperText={errors.licenceNo ? errors.licenceNo.message : null}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        name="expiry"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <>
                            <InputLabel shrink={!!value} htmlFor="expiry-text-field">
                              Date of Expiry (dd/mm/yyyy)
                            </InputLabel>
                            {isInternationalDL && <FormControlLabel
                              onChange={(e) => handleCheckboxChange(e, onChange)}
                              control={
                                <StyledCheckbox />

                              }
                              label={
                                <span style={{ fontSize: 12 }}>My Driver&apos;s License Does Not Have Expiry</span>
                              }
                              style={{ marginLeft: "0px" }}
                            />}
                            {!noExpiryChecked && <InputMask
                              alwaysShowMask={false}
                              formatChars={formatChars}
                              mask="dd/mm/yyyy"
                              maskChar=" "
                              disabled={isDisableExpiry}
                              onChange={(e) => onChange(e.target.value)}
                              value={value}
                            >
                              {(inputProps) => (
                                <TextField
                                  id="expiry-text-field"
                                  placeholder="Date of Expiry (dd/mm/yyyy)"
                                  fullWidth
                                  required
                                  value={inputProps.value}
                                  error={errors.expiry ? true : false}
                                  helperText={errors.expiry ? errors.expiry.message : null}
                                />
                              )}
                            </InputMask>}

                          </>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        control={control}
                        name="regionOfIssue"
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            label="regionOfIssue"
                            disableClearable
                            options={options
                              .sort(
                                (a, b) => -b.countryFirstLetter.localeCompare(a.countryFirstLetter)
                              )
                              .sort()}
                            groupBy={(option) => option.country}
                            getOptionLabel={(option) => option.label}
                            value={value}
                            renderOption={(option) => option.label}
                            getOptionSelected={(option) => option.label}
                            renderInput={(params) => (
                              <TextField
                                inputProps={{
                                  autoComplete: "new-password",
                                }}
                                {...params}
                                fullWidth
                                required
                                label="State/Country Of Issue"
                                error={errors.regionOfIssue ? true : false}
                                helperText={
                                  errors.regionOfIssue ? errors.regionOfIssue.message : null
                                }
                              />
                            )}
                            onChange={(_, newValue) => {
                              setValue("regionOfIssue", newValue);
                            }}
                          />
                        )}
                      />
                    </Grid> */}
                    {/* {
                      //Only show additional driver form, if main driver required for id/cc verify
                      (checkin.verifyCC && checkin.verifyID) && <>
                        <Grid item xs={12} md={6} style={{ marginBottom: 10 }}>
                          <AddDriverForm setCompletedQuestionaire={setAddDriverQuestionaireCompleted} completed={addDriverQuestionaireCompleted} openUncompleteAddDriverAlert={openUncompleteAddDriverAlert} setOpenUncompleteAddDriverAlert={setOpenUncompleteAddDriverAlert} />
                        </Grid>
                      </>
                    } */}

                    <Grid item xs={12} style={{ marginTop: 10, position: "fixed", bottom: "20px", zIndex:"10" }}>
                      <form>
                        <Button
                          style={{ borderRadius:"10px" }}
                          fullWidth
                          loading={checkin.loading}
                          title={<strong>Confirm &amp; Complete Check-in</strong>}
                          type="submit"
                          onClick={
                            handleClickedSubmit(),
                            handleSubmit(onSubmit)}
                        />
                      </form>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            {/* {checkin?.details?.WebRates?.Success ? (
            <Grid item xs={12} lg={8} md={10} style={{ marginTop: 20 }}>
              <Accordion
                className={classes.accordion}
                expanded={expandedExtras}
                onChange={() => setExpandedExtras(!expandedExtras)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
                  aria-controls={`panel2a-content`}
                  id={`panel2a-header`}
                  className={classes.summary}
                >
                  <Typography variant={"h3"}>Choose Extras</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container direction="row" justify="flex-start" alignItems="center">
                    {checkin?.options?.Options
                      ? checkin.options.Options.map((value, index) => {
                          return (
                            <Grid item xs={12} md={6} lg={3} key={index}>
                              <ExtrasCard
                                title={value.desc}
                                code={value.code}
                                maxQty={value.maximum_days}
                                imgHref="https://dummyimage.com/50x50/fff/000.png"
                                imgAlt="alt"
                                price={value.rate}
                              />
                            </Grid>
                          );
                        })
                      : ""}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          ) : (
            ""
          )} */}
          </Grid>
        </ThemeProvider>
        <Dialog
          open={dialogBox}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {checkin.country == "AU"
                ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1800 55 00 78. Please quote your driver’s licence number and reservation number."
                : "Unfortunately your profile has been restricted, please contact our New Zealand Customer Service Team on 0800 921 460. Please quote your driver’s licence number and reservation number."}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button fullWidth onClick={handleClose} loading={checkin.loading} title={"Continue"} />
          </DialogActions>
        </Dialog>

        <Dialog
          open={expiryDateDialogBox.dialogue}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleDialogeClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            <Typography variant="h3" align="center" className={classes.wrapIcon}>
              <WarningRounded color={"error"} fontSize={"large"} />
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText className={classes.root} id="alert-dialog-slide-description">
              {
                "Please be aware, your current drivers licence expiry date falls within the dates of your rental period. Please make sure you arrange and present your updated licence to the rental location once it has been renewed. Failing to provide a licence that is valid for the entire period of the rental prior to pick-up will result in your booking being cancelled"
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              onClick={handleDialogeClose}
              // loading={checkin.loading}
              title={"Continue"}
            />
          </DialogActions>
        </Dialog>

        <Dialog open={willExpire && !letSessionExpire}>
          <DialogTitle style={{ textAlign: "center" }}>
            <IconButton aria-label="close" onClick={(e) => setLetSessionExpire(true)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>Your session will expire in 1 minute.</DialogContent>
          <DialogActions>
            <Divider />
            <Grid spacing={1} container direction="row" justify="center">
              <Grid container item xs={12} justify="center">
                <Fab color="primary" variant="extended" onClick={onExtendSession}>
                  Extend My Session
                </Fab>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Dialog open={redirectToVerify}>
          <DialogTitle style={{ textAlign: "center" }}>
            <IconButton aria-label="close" onClick={() => setRedirectToVerify(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>Your personal details been changed, Click below to verify your ID.</DialogContent>
          <DialogActions>
            <Divider />
            <Grid spacing={1} container direction="row" justify="center">
              <Grid container item xs={12} justify="center">
                <Fab color="primary" variant="extended" onClick={handleConfirmRedirectToVerify}>
                  Confirm
                </Fab>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        {/* {reservationNumber != "" && (
          <img
            src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g, '_')}.png?b=${reservationNumber}&a=${verifyFailed ? "void_failed" : "view"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}`}
            style={{ display: "none" }}
          />
        )} */}
      </div>
    ))
  // );
};
const useStyles = makeStyles((theme) => ({
  accordion: {
    marginLeft: 10,
    marginRight: 10,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "none",
    "&.Mui-expanded": {
      margin: 10,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
  },
  headerFont: {
    color: "black",
  },
  summary: {
    backgroundColor: "#ffffff00",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  groupLabel: {
    backgroundColor: "blue",
  },
  removeContainer: {
    ".pac-container:after": {
      content: "none !important",
    },
  },
  wrapIcon: {
    verticalAlign: "middle",
    display: "block",
  },
  root: {
    textAlign: "center",
    color: "red",
  },
  container: {
    position: "relative",
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  divider: {
    height: theme.spacing(2),
  },
  typography: {
    color: "red",
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: `${theme.palette.primary.white}`,
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
      border: `1px solid ${theme.palette.primary.darkergrey}`
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.ocean
    },
  },
  checkedIcon: {
    backgroundColor: `${theme.palette.primary.main}`,
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""'
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.ocean
    }
  },
}));

export default CheckinApp;
